module.exports = __webpack_public_path__ + "img/fapiaoguanli.222b56cc.png";